function ReversibleOrderEditor() {
    
}

ReversibleOrderEditor.saveAndPreviewReversible = function() {
    var isReversible = _.isEqual(ub.config.isReversible, "1");
    var onReversibleSide2 = _.isEqual(ub.config.isEmbedded, "1");
    var parentWindow = window.parent;

    ProlookOrderEditor.funcs.prepareSizingBreakDown();
    ProlookSaveDesign.utilities.getPriceItemCode();
    ProlookSaveDesign.utilities.sortedModifierLabels();
    ProlookSaveDesign.utilities.setMaterialInfo();
    ProlookSaveDesign.funcs.prepareThumbnails();
    
    ub.current_material.settings.thumbnails = {
        front_view  : "",
        back_view   : "",
        left_view   : "",
        right_view  : "",
    };
    
    parentWindow.Loader.loading(1, 9);

    ProlookSaveDesign.funcs.uploadThumbnails(function() {
        parentWindow.Loader.loading(3, 9);
        var designPayload = SaveDesign.prepareSaveDesignPayload();
        SaveDesign.postSaveDesign(designPayload, function(response) {
            if (response.data.success) {
                // Save Design ID
                parentWindow.Loader.loading(5, 9);
                ub.current_material.settings.savedDesignID = response.data.sd_id;
                ProlookReversible.funcs.saveTheOtherSide(ub.current_material.settings);
            } else {
                ProlookOrderEditor.funcs.onErrorSavingDesign();
            }
        }, function(error) {
            ProlookOrderEditor.funcs.onErrorSavingDesign();
        });
    });
}

ReversibleOrderEditor.saveTheOtherSide = function(builderCustomization) {
    var onReversibleSide2 = _.isEqual(ub.config.isEmbedded, "1");
    var parentWindow = window.parent;
    var side1 = onReversibleSide2 ? builderCustomization : ub.current_material.settings;
    var side2 = onReversibleSide2 ? ub.current_material.settings: builderCustomization;

    var pdfPayload = [
        {
            index: 0,
            settings: side1
        },
        {
            index: 1,
            settings: side2
        }
    ]

    ProlookOrderEditor.funcs.prepareSizingBreakDown();
    ProlookSaveDesign.utilities.getPriceItemCode();
    ProlookSaveDesign.utilities.sortedModifierLabels();
    ProlookSaveDesign.utilities.setMaterialInfo();
    ProlookSaveDesign.funcs.prepareThumbnails();

    ub.current_material.settings.thumbnails = {
        front_view  : "",
        back_view   : "",
        left_view   : "",
        right_view  : "",
    };

    ProlookSaveDesign.funcs.uploadThumbnails(function() {
        var designPayload = SaveDesign.prepareSaveDesignPayload();
        parentWindow.Loader.loading(7, 9);
        SaveDesign.postSaveDesign(designPayload, function(response) {
            // Loader
            parentWindow.Loader.loading(8, 9);

            if (response.data.success) {
                // Save Design ID
                ub.current_material.settings.savedDesignID = response.data.sd_id;

                // Generating PDF
                PdfPanel.pdfBuilderReversible(pdfPayload, function(response) {
                    parentWindow.Loader.loading(9, 9);
                    if (response.success) {
                        side1.pdfOrderForm = response.pdfUrl;
                        side2.pdfOrderForm = response.pdfUrl;
                        ProlookOrderEditor.renderPreview(side1.thumbnails, side2.thumbnails, response.pdfUrl);
                    } else {
                        ProlookOrderEditor.funcs.onErrorPDF();
                    }
                }, function(error) {
                    ProlookOrderEditor.funcs.onErrorPDF();
                })
            } else {
                ProlookOrderEditor.funcs.onErrorSavingDesign();
            }
        }, function(error) {
            ProlookOrderEditor.funcs.onErrorSavingDesign();
        });    
    });
}

ReversibleOrderEditor.updateReversibleDesignOrder = function() {
    var parentWindow = window.parent;
    
    parentWindow.Loader.orderItem.updating();
    parentWindow.Loader.loading(1, 9);

    SaveDesign.updateSavedDesignBuilderCustomization(function(response) {
        if (response.success) {
            parentWindow.Loader.loading(3, 9);
            ProlookReversible.funcs.updateTheOtherSide(ub.current_material.settings);
        } else {
            ProlookOrderEditor.funcs.onErrorSavingDesign();
        }
    }, function(error) {
        funcs.onErrorSavingDesign();
    })
}

ReversibleOrderEditor.updateTheOtherSide = function(builderCustomization) {
    var parentWindow = window.parent;
    var onReversibleSide2 = _.isEqual(ub.config.isEmbedded, "1");
    var side1 = onReversibleSide2 ? builderCustomization : ub.current_material.settings;
    var side2 = onReversibleSide2 ? ub.current_material.settings: builderCustomization;

    SaveDesign.updateSavedDesignBuilderCustomization(function(response) {
        if (response.success) {
            parentWindow.Loader.loading(7, 9);
            ReversibleOrderEditor.updateOrderItem(side1, side2, function() {
                parentWindow.Loader.endloading(function() {
                    parentWindow.ub.funcs.showNotification("Design successfully updated. Redirecting to order item page.", "success", 3000);

                    // Add Confirmation Modal Here
                    _.delay(function() {
                        var redirect = ub.config.host + '/orders/' + ub.config.orderCode;

                        if (typeof parentWindow.document.referrer !== "undefined") {
                            parentWindow.location.href = parentWindow.document.referrer;
                        } else {
                            parentWindow.location.href = redirect;
                        }
                    }, 2000)
                });
            }, function() {
                ProlookOrderEditor.funcs.onErrorUpdatingOrderDesign();
            });
        } else {
            ProlookOrderEditor.funcs.onErrorSavingDesign();
        }
    }, function(error) {
        funcs.onErrorSavingDesign();
    })
};

ReversibleOrderEditor.updateOrderItem = function(side1, side2, successHandler, errorHandler) {
    var _url = ub.config.api_host + '/api/order_item/update';
    var orderSetting = ub.config.order_data;
    var data = {
        "parent_order_item_id": ub.config.order_item,
        "order_id": ub.config.orderCode,
        "factory_order_id": null,
        "pid": null,
        "item_id": ub.current_material.material.item_id,
        "description": ub.current_material.material.name,
        "builder_customizations": JSON.stringify(side1),
        "design_sheet": window.parent.ub.current_material.settings.pdfOrderForm,
        "set_group_id": null,
        "status": "new",
        "shipped_date": "0000-00-00",
        "esd": "0000-00-00",
        "questions": null,
        "roster": JSON.stringify(orderSetting.roster),
        "attached_files": "[]",
        "additional_attachments": null,
        "notes": null,
        "brand": "prolook",
        "application_type": ub.config.uniform_application_type,
        "customizer_style_id": ub.current_material.material.id,
        "shipping": null,
        "reversible_side_a_type": "outer",
        "reversible_side_b_type": "inner",
        "reversible_side_b_customizations": JSON.stringify(side2),
        "line_item_id": ub.config.line_item_id
    };

    $.ajax({
        url: _url,
        dataType: "json",
        type: "POST",
        data: JSON.stringify(data),
        crossDomain: true,
        contentType: 'application/json',
        headers: {
            "accessToken": (ub.user !== false) ? atob(ub.user.headerValue) : null
        },
    
        success: successHandler,

        erorr: errorHandler
    });
};